import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { COMPANY } from "@/data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-slate-900 text-slate-300 mt-24">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <span className="inline-flex bg-white rounded-xl px-4 py-3 mb-5">
          <img src={COMPANY.logo} alt="Equinoxe Propreté" className="h-12 w-auto" />
        </span>
        <p className="text-sm leading-relaxed max-w-md text-slate-400">
          Equinoxe Propreté, filiale du {COMPANY.group}, vous accompagne pour l'entretien de vos
          espaces dans le Lot. Clarté, fraîcheur et propreté à Cahors, Cazals, et leurs alentours.
        </p>
      </div>

      <div>
        <h4 className="text-white font-semibold mb-4">Navigation</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/services" className="hover:text-sky-400">Services</Link></li>
          <li><Link to="/contact" className="hover:text-sky-400">Devis gratuit</Link></li>
          <li><Link to="/login" className="hover:text-sky-400">Espace admin</Link></li>
          <li><Link to="/mentions-legales" className="hover:text-sky-400">Mentions légales</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-white font-semibold mb-4">Contact</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex items-center gap-2">
            <Phone size={16} className="text-sky-400" />
            <a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-sky-400">{COMPANY.phone}</a>
          </li>
          {COMPANY.addresses.map((a) => (
            <li key={a} className="flex items-center gap-2">
              <MapPin size={16} className="text-sky-400" /> {a}
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className="border-t border-slate-800 py-6 text-center text-xs text-slate-500">
      © {new Date().getFullYear()} {COMPANY.name} — Filiale du {COMPANY.group}. Tous droits réservés. Propulsé par{" "}
      <a href="https://www.equinoxe.studio" target="_blank" rel="noopener noreferrer" className="text-sky-400 hover:text-sky-300 font-medium">
        Equinoxe Studio
      </a>.
    </div>
  </footer>
);
